import React, { FC, useMemo, useCallback, useState } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import clone from 'lodash/clone';
import { IBreadcrumb } from 'common/interfaces/common';
import BreadcrumbContext, { IBreadcrumbContext } from 'common/contexts/BreadcrumbContext';

interface IBreadcrumbContextProvider {
  breadcrumbs: IBreadcrumb[];
  children: JSX.Element;
}

const BreadcrumbContextProvider: FC<IBreadcrumbContextProvider> = ({
  breadcrumbs: bcs,
  children,
}) => {
  const [breadcrumbs, setBreadcrumbs] = useState<IBreadcrumb[]>(bcs);

  const updateLastBreadcrumbLabel = useCallback((label: string): void => {
    setBreadcrumbs(prevBcs => {
      if (prevBcs.length) {
        const newBcs = cloneDeep(prevBcs);
        const lastBc = clone(newBcs.pop());

        if (lastBc) {
          lastBc.labelPostfix = label;
          return [...newBcs, lastBc];
        }
      }

      return prevBcs;
    });
  }, []);

  const contextValue = useMemo((): IBreadcrumbContext => {
    return { breadcrumbs, updateLastBreadcrumbLabel, setBreadcrumbs };
  }, [breadcrumbs, updateLastBreadcrumbLabel]);

  return <BreadcrumbContext.Provider value={contextValue}>{children}</BreadcrumbContext.Provider>;
};

export default BreadcrumbContextProvider;
